import { cn } from '@/lib/utils';

const totalRowClass =
  'flex items-baseline justify-between gap-4 px-4 pb-[18px] pt-3.5 text-sm text-neutral-600 @min-[600px]:px-7';
const totalValueClass = 'font-semibold tabular-nums text-ink';

/** Stopka karty z tabelą — podpis sumy po lewej, kwota po prawej. */
const PaymentTableTotalRow = ({
  label,
  value,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  label: string;
  value: React.ReactNode;
}) => (
  <div className={cn(totalRowClass, className)} {...props}>
    <span>{label}</span>
    <span className={totalValueClass}>{value}</span>
  </div>
);

export default PaymentTableTotalRow;
